import { render } from "./App.vue?vue&type=template&id=3d636a53"
const script = {}

import "./App.vue?vue&type=style&index=0&id=3d636a53&lang=css"

import exportComponent from "/var/www/html/resources/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__